import axios from 'axios';

import { useServicerStore } from '../store';

const BillService = {
  async createBill({ formValues, loanId, type }) {
    const values = { ...formValues, loan_id: loanId, type };

    if (values.payee_type === 'vendor') {
      values.lender_id = null;
      values.borrower_id = null;
    }

    if (values.payee_type === 'lender') {
      values.vendor_id = null;
      values.borrower_id = null;
    }

    if (values.payee_type === 'servicer') {
      values.vendor_id = null;
      values.lender_id = null;
      values.borrower_id = null;
    }

    const response = await axios.post('/bill', values);

    return response.data;
  },

  async updateBill({ formValues, loanId, type, billId }) {
    const values = {
      ...formValues,
      loan_id: loanId,
      type,
    };

    if (values.payee_type === 'vendor') {
      delete values.lender_id;
    }

    if (values.payee_type === 'lender') {
      delete values.vendor_id;
    }

    if (values.payee_type === 'servicer') {
      delete values.vendor_id;
      delete values.lender_id;
    }

    const response = await axios.put(`/bill/${billId}`, values);

    return response.data;
  },

  async getBills({ status, type, loanIds, vendorId, lenderId, borrowerId }) {
    const response = await axios.get('/bill', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        status,
        type,
        loan_ids: loanIds,
        vendor_id: vendorId,
        lender_id: lenderId,
        borrower_id: borrowerId,
      },
    });

    return response.data;
  },

  async getBill(billId) {
    const response = await axios.get(`/bill/${billId}`);

    return response.data;
  },

  async deleteBill(billId) {
    const response = await axios.delete(`/bill/${billId}`);

    return response.data;
  },

  async payBillNow(billId) {
    const response = await axios.post(`/bill/${billId}/pay_now`);

    return response.data;
  },

  async payBillFromOutside(billId) {
    const response = await axios.post(`/bill/${billId}/pay_now_from_outside`);

    return response.data;
  },

  async setupBillForNextYear(billId) {
    const response = await axios.post(`/bill/${billId}/setup_next_year`);

    return response.data;
  },
};

export default BillService;
